/** CORS-simple content type — avoids OPTIONS preflight for cross-origin beacons/fetch. */
const ANALYTICS_CONTENT_TYPE = "text/plain;charset=UTF-8";

export const postAnalytics = (url: string, body: string): void => {
  if (typeof navigator.sendBeacon === "function") {
    const blob = new Blob([body], { type: ANALYTICS_CONTENT_TYPE });
    if (navigator.sendBeacon(url, blob)) return;
  }

  void fetch(url, {
    method: "POST",
    headers: { "Content-Type": ANALYTICS_CONTENT_TYPE },
    body,
    keepalive: true,
    mode: "cors",
  });
};
